export default{
    namespaced: true,

    state:{
        fechaDe:null,
        fechaA:null,
        statusSol:[
            {value:1, text:"Solicitado", color:"blue"},
            {value:2, text:"Atendido", color:"orange"},
            {value:3, text:"Cerrado", color:"green"},
            {value:90, text:"Cancelado", color:"red"},
        ],
        tipoSol:[
            {value:1, text:"Mant. Preventivo"},
            {value:2, text:"Mant. Correctivo"},
            {value:3, text:"Instalación"},
            {value:4, text:"Contrato"},
            {value:5, text:"Garantia"},
            {value:6, text:"Capacitación"},
            {value:90, text:"Otro"},
        ],
        estadoEquipo:[
            {value:1, text:"Funcional"},
            {value:2, text:"Con fallos"},
            {value:90, text:"Fuera de servicio"},
        ],
        solicitudesList:[],
        total: 0,
        page:1,

        // Para el listado de quipos
        equiposList:[],
        pageEq:1,
        totalEq:0,


    },
    mutations:{
        CAMBIA_FECHA_DE(state, data){
            //console.log(data.root)
            state.fechaDe = data
        },
        CAMBIA_FECHA_A(state, data){
            //console.log(data.root)
            state.fechaA = data
        },

        CAMBIA_LISTA_SOLICITUDES(state, data){
            state.solicitudesList = data.root
            state.total = data.total
        },
        CAMBIA_PAGE(state, data){
            state.page = data
        },

        CAMBIA_LISTA_EQUIPOS(state, data){
            state.equiposList = data.root
            state.totalEq = data.total
        },
        CAMBIA_PAGE_EQUIPOS(state, data){
            state.pageEq = data
        },
        


    },
    actions:{
        //
    },
    getters:{
        //
    },
}